import Vue from 'vue';

export default {
    namespaced: true,
    // -----------------------------------------------------------------
    state: {
        schedule: [],
        overview: null,
        current_week: 1
    },
    // -----------------------------------------------------------------
    getters: {
        current: (state) => { return state.schedule[state.current_week] || {} },
        next: (state) => { return state.schedule[state.current_week + 1] || {} },
        previous: (state) => { return state.schedule[state.current_week - 1] || {} },
        all: (state) => { return state.schedule },
        currentWeek: (state) => { return state.current_week },
        overview: (state) => { return state.overview }
    },
    // -----------------------------------------------------------------
    mutations: {
        SET_SCHEDULE(state, { schedule, week }) {
            this._vm.$set(state.schedule, week - 1, schedule)
        },
        SET_SCHEDULE_OVERVIEW(state, overview) {
            state.overview = overview
            state.schedule.forEach(item => {
                let lockedWeek = overview.locked_states.find(lockedState => lockedState.week === item.week)
                if (lockedWeek) {
                    item.diary_entries.forEach(de => {
                        let lockedState = lockedWeek.diary_entries.find(lockedEntry => lockedEntry.date === de.date)
                        if (lockedState) {
                            de.locked = lockedState.locked
                        }
                    })
                }
            })
        },
        SET_SCHEDULE_DAY(state, { day, week }) {
            let week_index = state.schedule.findIndex((w) => w && w.week === week)
            if (week_index !== -1) {
                let index = state.schedule[week_index].diary_entries.findIndex((d) => d.date === day.date)
                if (index !== -1) this._vm.$set(state.schedule[week_index].diary_entries, index, day)
            }
        },
        SET_CURRENT_WEEK(state, week) {
            if (week === 0) week = 1
            state.current_week = week
        },
        INCREMENT_CURRENT_WEEK(state, total_weeks) {
            if (state.current_week < total_weeks)
                state.current_week++
        },
        DECREMENT_CURRENT_WEEK(state) {
            if (state.current_week > 1)
                state.current_week--
        },
        RESET(state) {
            state.schedule = []
            state.overview = null
            state.current_week = 1
        }
    },
    // -----------------------------------------------------------------
    actions: {
        // -----------------------------------------------------------------
        // SCHEDULE SPECIFIC
        // 
        // -----------------------------------------------------------------
        createDay: (context, scheduleData) => {
            return Vue.api.post(`users/${scheduleData.user_id}/schedules/${scheduleData.week}/days`, scheduleData)
                .then(response => {
                    context.commit('SET_SCHEDULE_DAY', { day: response.data.data, week: scheduleData.week })
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        readSchedule: (context, { user_id, week }) => {
            let week_index = context.getters.all.findIndex((w) => w && w.week === week)
            if (week_index !== -1) return

            return Vue.api.get(`users/${user_id}/schedules/${week}`)
                .then(response => {
                    context.commit('SET_SCHEDULE', { schedule: response.data.data, week: week })
                })
                .catch(error => { throw error.response.data.error })
        },
        updateSchedule: (context, { user_id, data }) => {
            return Vue.api.put(`users/${user_id}/schedules/${data.week_id}`, data)
                .then(() => {

                })
                .catch(error => { throw error.response.data.error })
        },
        readScheduleDay: (context, { user_id, day, week }) => {
            return Vue.api.get(`users/${user_id}/schedules/${week}/days/${day}`)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        updateDay: (context, scheduleData) => {
            return Vue.api.put(`users/${scheduleData.user_id}/schedules/${scheduleData.week}/days/${scheduleData.id}`, scheduleData)
                .then(response => {
                    context.commit('SET_SCHEDULE_DAY', { day: response.data.data, week: scheduleData.week })
                })
                .catch(error => { throw error.response.data.error })
        },
        readScheduleWeek: (context, user_id) => {
            return Vue.api.get(`users/${user_id}/schedules`)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        readScheduleOverview(context, { user_id, force }) {
            if (context.getters.overview && !force) return context.getters.overview

            return Vue.api.get(`users/${user_id}/schedules/overview`)
                .then(response => {
                    if (context.getters.overview && context.getters.overview.updated_at === response.data.data.updated_at) {
                        return context.getters.overview
                    }
                    context.commit('SET_SCHEDULE_OVERVIEW', response.data.data)
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        recalculateSchedule(context, { user_id, week }) {
            return Vue.api.post(`users/${user_id}/schedules/${week}/recalculate`).then(response => {
                return response.data.data
            })
                .catch(error => { throw error.response.data.error })
        },
        indexDays: (context, { user_id, data }) => {
            return Vue.api.get(`users/${user_id}/days`, { params: data })
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },

        setWeek(context, week) {
            context.commit('SET_CURRENT_WEEK', week)
        },

        incrementWeek(context) {
            context.commit('INCREMENT_CURRENT_WEEK', context.rootState.user.user.user.total_weeks)
        },

        decrementWeek(context) {
            context.commit('DECREMENT_CURRENT_WEEK')
        },

        resetSchedule(context, { user_id, data }) {
            return Vue.api.post(`users/${user_id}/schedules/reset`, data)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        }
    }
}